import { faSpinner } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import './Style/Loading.css';

type loadingProps = {
    loadingMessage: string;
}

const Loading: React.FC<loadingProps> = ({ loadingMessage }) => {
    return (
        <div className="loading-wrapper">
            <div className="loading-content">
                <FontAwesomeIcon icon={faSpinner} spin size="4x" color="#0477BF"/>
                <p className="loading-message">{ loadingMessage } </p>
            </div>
        </div>
    )
}

export default Loading